exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_object-gops.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_object-gops.js
// module chunks = 0